import Message from '@/components/Message';
import Modal from '@/components/Modal/';
import { noop } from '@/utils/util';
import Ajax from '@/utils/ajax';
import { getUserOtpChannelState } from '@/reducers/User/UserReducer';
import { User } from '@/constants/actionTypes';
import { getUserOtpChannel } from '@/actions/UserAction';
import NestLoading from '@/components/Loading/NestLoading';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import styles from './VerifyModal.scss';

@connect(
  state => ({
    userOtpChannel: getUserOtpChannelState(state),
  }),
  dispatch => ({
    getUserOtpChannel: () => dispatch(getUserOtpChannel()),
  }),
)
export default class VerifyModal extends Component {
  static defaultProps = {
    onModalCancelClick: noop,
    onModalConfirmBtnClick: noop,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      confirming: false, // 正在验证验证码
      sending: false, // 正在请求发送验证吗
      curChannel: this.getCurChannel(),
      curSecond: 0, // 倒计时秒数
      isResendCaptcha: false, // 是否是重发验证码
    };
  }

  componentWillReceiveProps(nextProps) {
    const { visible } = nextProps;
    const otpCapstatus = nextProps.userOtpChannel.get('status');
    if (otpCapstatus !== User.GET_USER_OTP_CHANNEL_SUCCESS) {
      nextProps.getUserOtpChannel();
    }
    this.setState({
      curChannel: this.getCurChannel(nextProps),
    });
    // 重新显示
    if (visible && !this.props.visible) {
      this.setState({
        isResendCaptcha: false,
      });
      if (this.inputRef) {
        this.inputRef.value = ''; // 清空input
      }
    }
  }

  getCurChannel = (props = this.props) => {
    const userOtpChannelData = this.getOtpChannelData(props);
    if (!userOtpChannelData) {
      return '';
    }
    // 优先sms
    if (userOtpChannelData.get('sms')) {
      return 'sms';
    }
    if (userOtpChannelData.get('email')) {
      return 'email';
    }

    return '';
  };

  onConfirmBtnClick = () => {
    const { confirming } = this.state;
    const { onModalConfirmBtnClick } = this.props;
    const captcha = (this.inputRef.value || '').trim();
    if (captcha && !confirming) {
      this.setState({
        confirming: true,
      });
      Ajax.verifyCaptcha({ code: captcha }).then(() => {
        this.setState({
          confirming: false,
        });
        onModalConfirmBtnClick();
      }).catch((...args) => {
        Message.error(i18n.get('verifymodal.verify-captcha-error'));
        this.setState({
          confirming: false,
        });
      });
    } else {
      Message.error(i18n.get('verifymodal.empty-captcha'));
    }
  };

  switchBtnClick = (e) => {
    const chanel = e.target.getAttribute('data-chanel');
    this.setState({
      curChannel: chanel,
    });
  };

  startConutDown = (total) => {
    clearInterval(this.captchaTimer);
    this.setState({
      curSecond: total,
    });
    this.captchaTimer = setInterval(() => {
      let { curSecond, isResendCaptcha } = this.state;
      curSecond -= 1;
      if (curSecond <= 0) {
        clearInterval(this.captchaTimer);
        curSecond = 0;
        isResendCaptcha = true;
      }
      this.setState({ curSecond, isResendCaptcha });
    }, 1000);
  };

  sendCaptcha = (e) => {
    const { curChannel, curSecond, sending } = this.state;
    if (curSecond || sending) {
      return;
    }
    this.setState({ sending: true });
    Ajax.sendCaptcha({ channel: curChannel })
      .then(() => {
        this.startConutDown(60);
        this.setState({ sending: false });
      })
      .catch((...args) => {
        Message.error(i18n.get('verifymodal.send-captcha-error'));
        this.setState({ sending: false });
      });
  };

  getOtpChannelData = (props = this.props) => {
    return props.userOtpChannel.get('data');
  };

  render() {
    const {
      error,
      curChannel,
      curSecond,
      isResendCaptcha,
      confirming,
    } = this.state;
    const { onModalCancelClick, visible } = this.props;
    const userOtpChannelData = this.getOtpChannelData();
    const sendBtnClass = classNames(styles['btn-in-resend'], {
      [styles['disable']]: !!curSecond,
    });
    let captchaBtnTip = 'verifymodal.send-captcha';
    if (curSecond) {
      captchaBtnTip = 'verifymodal.sending-captcha';
    } else if (isResendCaptcha) {
      captchaBtnTip = 'verifymodal.resend-captcha';
    }

    return (
      <Modal
        width={397}
        visible={visible}
        showFooter={false}
        maskClassName={styles['mask']}
        closable
        isMiddle
        title={i18n.get('verifymodal.title')}
        onCancel={onModalCancelClick}
      >
        <div className={styles['modal-body']}>
          <p className={styles['des']}>
            {i18n.get('verifymodal.des', { minute: 10 })}
          </p>
          <p className={styles['chanel-des']}>
            {curChannel && i18n.get(`verifymodal.${curChannel}-prefix`)}
            <span>
              {userOtpChannelData && userOtpChannelData.get(curChannel)}
            </span>
            {i18n.get('verifymodal.verify')}
          </p>
          <div className={styles['input-prepend']}>
            <i className="fa fa-shield"/>
            <input
              type="text"
              name="security"
              placeholder={i18n.get('verifymodal.captcha')}
              ref={(v) => {
                this.inputRef = v;
              }}
            />
            <a
              className={sendBtnClass}
              onClick={this.sendCaptcha}
            >
              {i18n.get(captchaBtnTip, { num: curSecond })}
            </a>
          </div>
          <div
            className={styles['confirm-btn']}
            onClick={this.onConfirmBtnClick}
          >
            {confirming ? i18n.get('verifymodal.confirming') : i18n.get('verifymodal.confirm')}
          </div>
          {
            curChannel === 'sms' && userOtpChannelData.get('email') &&
            <p
              className={styles['switch-btn']}
              onClick={this.switchBtnClick}
              data-chanel='email'
            >
              {i18n.get('verifymodal.by-email')}
            </p>
          }
          {
            curChannel === 'email' && userOtpChannelData.get('sms') &&
            <p
              className={styles['switch-btn']}
              onClick={this.switchBtnClick}
              data-chanel='sms'
            >
              {i18n.get('verifymodal.by-phone')}
            </p>
          }
          {
            !userOtpChannelData &&
            <NestLoading loading tip={i18n.get('verifymodal.loading')}/>
          }
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VerifyModal/VerifyModal.js